module.exports = __webpack_public_path__ + "media/images/photo/plans/places/sankeien-eb69d00735938ecee7b5b25e9c3dcafb.png";